import { AbstractAdapter } from '@shared/helpers/abstract.adapter';
import { ICategory } from '@shared/interfaces/ICategory.interface';
import { Injectable } from '@angular/core';

export class BlogCategory implements ICategory {
  id: number;
  slug: string;
  name: string;
  description: string;
  marker: string;
  color: string;
  position: number;
  active: string;
  types: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class BlogCategoryAdapter extends AbstractAdapter {
  private mapper = {
    id: {},
    slug: {},
    name: {},
    description: {},
    marker: {},
    color: {},
    position: {},
    types: {},
    active: {}
  };

  constructor() {
    super();
  }

  adapt(item: any, mapper?: unknown): BlogCategory {
    const category = new BlogCategory();
    const adaptMapper = (typeof mapper === 'object') ? mapper : this.mapper;
    super.processMapping(adaptMapper, item, category);

    return category;
  }
}
